const TextureSlots = {
    BaseColor: 5,
    MetallicRoughness: 6,
    Normal: 7,
    Occlusion: 8,
    Emission: 9,
    LUT: 10,
    ShadowMap0: 11,
};

export default TextureSlots;
